import React from 'react';
import { Form } from 'react-bootstrap';
import { FieldErrors, FieldValues, Path, UseFormRegister } from 'react-hook-form';

interface Props<T extends FieldValues> {
  errors: FieldErrors<T>;
  label: string;
  name: Path<T>;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  register: UseFormRegister<T>;
  required?: boolean;
  type?: string;
}

export const FormField = <T extends FieldValues>({
  errors,
  label,
  name,
  onChange,
  placeholder,
  register,
  required,
  type,
}: Props<T>) => (
  <Form.Group className="mb-3 w-auto">
    <label className="small pb-1">
      {label}
      {required ? '*' : ''}
    </label>
    <Form.Control
      required={required}
      type={type}
      {...register(name)}
      isInvalid={!!errors[name]}
      onChange={onChange}
      placeholder={placeholder}
    />
    <Form.Control.Feedback type="invalid">{errors[name]?.message as string}</Form.Control.Feedback>
  </Form.Group>
);
